export default __webpack_public_path__ + "static/media/Screenshot_4.0de71af2.png";